import AxiosService from './axios.service';
import { AxiosResponse } from 'axios';
import { CreateHojaDeVidaDto, HojaDeVida } from './types/types';

export class HojaDeVidaService {
  // POST /hoja-de-vida
  static async create(dto: CreateHojaDeVidaDto): Promise<HojaDeVida> {
    const response: AxiosResponse<HojaDeVida> = await AxiosService.post('/hoja-de-vida', dto);
    return response.data;
  }

  // GET /hoja-de-vida
  static async findAll(): Promise<HojaDeVida[]> {
    const response: AxiosResponse<HojaDeVida[]> = await AxiosService.get('/hoja-de-vida');
    return response.data;
  }

  // GET /hoja-de-vida/user/:rut
  static async findByUser(rut: string): Promise<HojaDeVida[]> {
    const response: AxiosResponse<HojaDeVida[]> = await AxiosService.get(`/hoja-de-vida/user/${encodeURIComponent(rut)}`);
    return response.data;
  }

  // GET /hoja-de-vida/:id
  static async findOne(id: string): Promise<HojaDeVida | null> {
    const response: AxiosResponse<HojaDeVida> = await AxiosService.get(`/hoja-de-vida/${id}`);
    return response.data;
  }

  // DELETE /hoja-de-vida/:id
  static async remove(id: string): Promise<void> {
    await AxiosService.delete(`/hoja-de-vida/${id}`);
  }
}